import {HStack, Stack, Text} from "@chakra-ui/react";
import * as React from "react";
import {StepperComponentProps} from "./StepperComponent.props";
import {useAppSelector} from "../../../hooks/use-store";

export const StepperComponent = ({index, hasLine = true}: StepperComponentProps) => {
    const {currentPage} = useAppSelector(state => state.landing);

    return <HStack>
        <Stack
            w={"48px"}
            h={"48px"}
            rounded={50}
            backgroundColor={(currentPage ?? 0) >= index ? "primary.400" : "surfaceContainerHighest.light"}>
            <Text fontSize={"28px"} mt={"2px"} color={"white"} textAlign={"center"}>{index + 1}</Text>
        </Stack>

        {hasLine &&
            <Stack w={"4vw"} h={"6px"} mx={"4px"} rounded={"8px"}
                   backgroundColor={(currentPage ?? 0 - 1) > index ? "primary.400" : "surfaceContainerHighest.light"}/>}
    </HStack>
}
